<template>
  <v-row align="center" justify="center">
    <v-col cols="12" class="text-center section-title py-5 px-10">
      <div class="content">
        <a class="" href="#" @click="goToAmazon">
          <img
            src="@/assets/images/icons/amazon_312x64.png"
            alt="Login in with Amazon"
            class="ml-auto"
            width="280"
          />
        </a>
      </div>
    </v-col>
    <v-col cols="12" class="text-center section-title py-5">
      <div class="content ">
        <div
          id="customBtn"
          class="customGPlusSignIn align-middle"
          v-on:click="goToGoogle"
        >
          <span class="icon"></span>
          <span class="buttonText">Sign in with Google</span>
        </div>
      </div>
    </v-col>
    <v-col cols="12" class="text-center section-title py-5">
      <div class="content">
        <div
          id="customAppleBtn"
          class="customGPlusSignIn"
          v-on:click="goToApple"
        >
          <span class="iconApple"></span>
          <span class="buttonText">Sign in with Apple</span>
        </div>
      </div>
    </v-col>

    <!-- End Blog Area  -->
  </v-row>
</template>

<style type="text/css">
#customBtn {
  display: inline-block;
  background: white;
  color: #444;
  width: 280px;
  height: 55px;
  border-radius: 5px;
  border: thin solid #888;
  box-shadow: 1px 1px 1px grey;
  white-space: nowrap;
}

#customAppleBtn {
  align-content: center;
  display: inline-block;
  background: white;
  color: #444;
  width: 280px;
  height: 55px;
  border-radius: 5px;
  border: thin solid #888;
  box-shadow: 1px 1px 1px grey;
  white-space: nowrap;
}

#customBtn:hover,
#customLWABtn:hover,
#customAppleBtn:hover {
  cursor: pointer;
}

span.label {
  font-family: serif;
  font-weight: normal;
}

span.icon {
  background-size: cover;
  background: url("../../assets/images/icons/google-normal.png") no-repeat;
  background-size: contain;
  display: inline-block;
  vertical-align: middle;
  width: 42px;
  height: 42px;
}

span.iconApple {
  background: url("../../assets/images/icons/apple-black.png") transparent 5px
    no-repeat;
  background-size: contain;
  display: inline-block;
  vertical-align: middle;
  width: 42px;
  height: 42px;
}

span.buttonText {
  display: inline-block;
  vertical-align: middle;
  padding-left: 12px;
  padding-right: 12px;
  font-size: 20px;
  font-weight: bold;
  /* Use the Roboto font that is loaded in the <head> */
  font-family: "Roboto", sans-serif;
}

.content_heading h4.heading-title {
  color: white;
  text-align: center;
  margin-bottom: 50px !important;
}

.im_box .content .inner {
  bottom: 75px;
}

.content_footer {
  bottom: 15px !important;
  color: white;
  font-size: small;
  text-align: center;
}
</style>
<script>
export default {
  components: {},
  data() {
    return {
      breadcrumbs: [
        {
          text: "Home",
          to: "/",
          disabled: false
        },
        {
          text: "Login",
          to: "",
          disabled: true
        }
      ]
    };
  },
  methods: {
    goToAmazon() {
      return this.$Amplify.Auth.federatedSignIn({
        provider: "LoginWithAmazon"
      });
    },
    goToApple() {
      return this.$Amplify.Auth.federatedSignIn({
        provider: "SignInWithApple"
      });
    },
    goToGoogle() {
      return this.$Amplify.Auth.federatedSignIn({
        provider: "Google"
      });
    }
  }
};
</script>
